<template>
	<Vcode
		:show="showSlide"
		:canvasWidth="canvasWidth"
		:canvasHeight="canvasHeight"
		@success="onSuccess"
		:range="5"
		@fail="onFail"
		@close="handleClose"
		:imgs="list"
		/>
</template>

<script>
import Vcode from "vue-puzzle-vcode"
export default {
	components: {
		Vcode
	},
	props: {
		isShow: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		showSlide: {
			get() {
				return this.isShow
			},
			set() {}
		},
		list() {
			let num = 18
			let arr = []
			for(let i = 1; i <= num; i++) {
				let imgUrl = require(`@/assets/image/${(i < 10 ? '00' : '0') + i}.png`)
				arr.push(imgUrl)
			}
			return arr
		}
	},
	data () {
		return {
			canvasWidth: 360,
			canvasHeight: 220,
			resizeHandler: null
		}
	},
	mounted() {
		this.updateCanvasSize()
		this.resizeHandler = () => {
			this.updateCanvasSize()
		}
		window.addEventListener('resize', this.resizeHandler)
	},
	beforeDestroy() {
		if (this.resizeHandler) {
			window.removeEventListener('resize', this.resizeHandler)
		}
	},
	methods: {
		updateCanvasSize() {
			const isMobile = window.innerWidth <= 767
			this.canvasWidth = isMobile ? 300 : 360
			this.canvasHeight = isMobile ? 180 : 220
		},
		onSuccess(v) {
			this.$emit('success', v)
		},
		onFail() {
			console.log('fail')
		},
		onRefresh() {
			console.log('refresh')
		},
		handleRefresh() {
			this.$refs.slideVerify.reset()
		},
		handleClose() {
			this.$emit('close')
		}
	}
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__header {
	padding: 0
}
::v-deep .el-dialog__footer {
	border-top: 1px solid #f2f2f2;
}
.btn-group {
	text-align: left;
}
</style>
